import React from "react";
import { Icon } from "semantic-ui-react";
export function InComponentErrorRenderer({ error, headerText }) {
    return (React.createElement("div", { className: "bg-red-50 border border-red-200 rounded-md p-4 mx-6 mt-4" },
        React.createElement("div", { className: "flex" },
            React.createElement("div", { className: "flex-shrink-0" },
                React.createElement(Icon, { name: "exclamation triangle", className: "h-5 w-5 text-red-400" })),
            React.createElement("div", { className: "ml-3" },
                React.createElement("h3", { className: "text-sm font-medium text-red-800" }, headerText ?? "Error"),
                React.createElement("div", { className: "mt-2 text-sm text-red-700" },
                    React.createElement("p", null, error))))));
}
